import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { communityPosts } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

export default function RepliesSection() {
  const highlights = communityPosts
    .flatMap((post) =>
      post.replies
        .filter((reply) => reply.essence)
        .map((reply) => ({ ...reply, postTitle: post.title, postId: post.id })),
    )
    .sort((a, b) => b.likes - a.likes)
    .slice(0, 5);

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          kicker="Top Replies"
          title="高赞神回复 · 评论区才是正文"
          desc="这些短评被点赞到置顶，一句话顶一整个帖子。看到喜欢的，点进去还能翻完整楼中楼。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {highlights.map((reply, index) => (
            <blockquote
              key={reply.id}
              className={`flex flex-col p-6 rounded-lg bg-background-50 border border-background-200 ${
                index === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-accent-100 text-accent-800 text-xs font-medium">
                  <i className="ri-award-line"></i>
                  加精神回复
                </span>
                <span className="text-xs text-foreground-400">
                  {formatCount(reply.likes)} 赞
                </span>
              </div>
              <p
                className={`mt-4 font-heading font-medium text-foreground-900 leading-relaxed ${
                  index === 0 ? "text-lg md:text-xl" : "text-base"
                }`}
              >
                「{reply.content}」
              </p>
              <footer className="mt-auto pt-5 flex items-center gap-2.5">
                <span className="w-8 h-8 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center text-xs font-medium">
                  {reply.author.slice(0, 1)}
                </span>
                <span className="min-w-0">
                  <span className="block text-sm text-foreground-800">{reply.author}</span>
                  <Link
                    to={`/post/${reply.postId}`}
                    className="block text-xs text-foreground-500 hover:text-primary-700 transition-colors truncate cursor-pointer"
                  >
                    出自：{reply.postTitle}
                  </Link>
                </span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}